import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDelivereasy = function SvgDelivereasy(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35 0H0v35h35V0ZM17.5 8a7.17 7.17 0 0 1 2.198.335c4.894 1.558 6.867 7.184 3.912 11.417-1.168 1.672-2.433 3.28-3.698 4.887-.522.664-1.044 1.329-1.56 1.997-.174.226-.366.438-.58.674l-.273.302a35.602 35.602 0 0 0-.272-.302c-.214-.236-.407-.448-.58-.674-.516-.668-1.038-1.333-1.56-1.997-1.265-1.607-2.53-3.215-3.699-4.887-2.954-4.233-.982-9.859 3.913-11.417A7.082 7.082 0 0 1 17.499 8Zm-3.934 7.137c-.029 2.14 1.705 3.936 3.86 3.989 2.096.053 3.953-1.737 4.003-3.86.053-2.09-1.643-3.892-3.71-3.938-2.304-.056-4.12 1.61-4.153 3.809Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgDelivereasy;